import {all, call, put, takeEvery} from 'redux-saga/effects'
import {ClientsActionTypes, fetchSuccess, fetchError} from '@actions/client';
import clientApi from '@api/client';


function* handleFetch() {
  try {
    const {data} = yield call(clientApi.getList);
    yield put(fetchSuccess(data))
  } catch (err) {
    yield put(fetchError(err))
  }
}



function* clientsSaga() {
  yield all([
    yield takeEvery(ClientsActionTypes.FETCH_REQUEST, handleFetch),
  ])
}

export default clientsSaga
